import { PropTypes } from 'prop-types'
import { useEffect, useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { Element } from '../html/element'
import { ScrollComponent } from '../scrollComponent'
import classes from './index.module.scss'

export const Tabs = ({
  items,
  isI18n,
  activeKey,
  onChange,
  children,
  tabListClassName,
  tabListStyle,
  getAppendStyleItem,
  styleContent,
  isScrollContent,
  tabClassName,
}) => {
  const [active, setActive] = useState(activeKey || items[0]?.key)

  useEffect(() => {
    if (activeKey) setActive(activeKey)
  }, [activeKey])

  const onClickTab = (item) => {
    if (onChange) {
      onChange(item.key)
    }
    setActive(item.key)
  }

  const renderContent = () => {
    if (active) {
      return items.find((item) => item.key === active)?.children
    }
  }

  return (
    <Element className={`${classes.tabs} ${tabClassName}`}>
      <Element
        className={[tabListClassName, classes.tabList].join(' ')}
        style={{ color: '#3A414B', ...tabListStyle }}
      >
        {items.map((item, index) => (
          <Element
            key={item.key}
            className={`${classes.tabItem} ${
              item.key === active ? classes.active : ''
            }`}
            style={{
              color: item.key === active ? '#2C73E8' : '',
              borderColor: '#2C73E8',
              ...getAppendStyleItem(
                item.key === active,
                index === 0,
                index === items.length - 1,
                items.length,
              ),
            }}
            onClick={() => onClickTab(item)}
          >
            {isI18n ? <Translate value={item.label} /> : item.label}
          </Element>
        ))}
      </Element>

      <Element style={styleContent} className={classes.tabContent}>
        {isScrollContent ? (
          <ScrollComponent>
            {renderContent()}
            {children}
          </ScrollComponent>
        ) : (
          <>
            {renderContent()}
            {children}
          </>
        )}
      </Element>
    </Element>
  )
}

Tabs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      children: PropTypes.node,
    }),
  ).isRequired,
  isI18n: PropTypes.bool,
  activeKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  tabListClassName: PropTypes.string,
  tabListStyle: PropTypes.object,
  getAppendStyleItem: PropTypes.func,
  isScrollContent: PropTypes.bool,
  styleContent: PropTypes.object,
  tabClassName: PropTypes.string,
}

Tabs.defaultProps = {
  items: [],
  isI18n: true,
  tabListClassName: '',
  tabListStyle: {},
  getAppendStyleItem: () => ({}),
  isScrollContent: true,
  tabClassName: '',
}
